import { render, staticRenderFns } from "./SelectedFormatGroupTab.vue?vue&type=template&id=469ad0ce&"
import script from "./SelectedFormatGroupTab.vue?vue&type=script&lang=ts&"
export * from "./SelectedFormatGroupTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports